{
  "User not found": "User not found",
  "About me": "About me",
  "Not available": "Coming soon",
  "Settings": "Settings",
  "Preferred language": "Choose language",
  "You need to enter a first and last name": "You need to enter a first and last name",
  "There were errors when trying to update your name:": "There were errors when trying to update your name:",
  "Saving language failed.": "Saving language failed",
  "Your name": "Insert name",
  "First name": "First name",
  "Last name": "Last name",
  "Save": "Save",
  "Request password": "Request password",
  "There is no password set for this account.": "There is no password set for this account",
  "Use the link below to request a password": "Use the link below to request a password",
  "Verification email sent.": "Verification email sent",
  "Change password": "Reset password",
  "Passwords do not match": "Passwords do not match",
  "old password": "Old password",
  "new password": "New password",
  "repeat password": "Repeat password",
  "Password updated": "Your password has been updated",
  "Update password": "Update password",
  "Roles": "Roles",
  "Id": "ID",
  "Space": "Space",
  "Try again later.": "Try again later",
  "If the issue persists, please contact support.": "If the issue persists, please contact support",

  "Password settings": "Password",
  "password-change-email-sent": "An email with instructions for changing your password was sent to {{email}}.\nIf you did not receive the email, please try again or contact support"
}
